/* eslint-disable @typescript-eslint/no-explicit-any */
import storage from './indexdb-store';
import { analyticsStateSlice, analyticsStateSliceReducerKey } from './analytics';
import { organizationStateSlice, organizationStateSliceReducerKey } from './organization';

const persistConfig = {
  key: 'pxp_store',
  storage: storage('pxp_store'),
  version: 1,
  transforms: [],
  blacklist: [],
};

let middleware: any[] = [];

const isDevelopment = process.env.NODE_ENV === 'development';
const isTest = process.env.NODE_ENV === 'test';
if (isDevelopment || isTest) {
  middleware = [...middleware];
}

const rootReducers = {
  [analyticsStateSliceReducerKey]: analyticsStateSlice.reducer,
  [organizationStateSliceReducerKey]: organizationStateSlice.reducer,
};

export { middleware, persistConfig, rootReducers };
